class StoreLocationDrawer extends HTMLElement {
  constructor() {
    super();
    this.selectedSize = [];
    this.storeTemplate = this.querySelector("template.store-template");
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.section = document.querySelector(`#${this.dataset.productInfo}`);
    this.variantData = JSON.parse(
      this.querySelector('[type="application/json"]').textContent
    );
    const overlay = this.querySelector('[class*="drawer__overlay"]');
if (overlay) {
  overlay.addEventListener("click", this.close.bind(this));
}

    this.setAccessibility();
    this.querySelectorAll(".store-location-drawer__option").forEach((option) =>
      option.addEventListener("click", this.onOptionSelect.bind(this))
    );
    this.querySelector('[data-action="size-submit"]').addEventListener(
      "click",
      this.onSizeSubmit.bind(this)
    );
    this.querySelector("form").addEventListener(
      "submit",
      this.searchLocation.bind(this)
    );
    this.initAutocomplete();
    // this.getProductLocations();
  }
  setAccessibility() {
    const trigger = document.querySelector(`[data-drawer="${this.id}"]`);
    if (!trigger) return;
    trigger.setAttribute("role", "button");
    trigger.setAttribute("aria-haspopup", "dialog");
    trigger.addEventListener("click", (event) => {
      event.preventDefault();
      this.show(trigger);
    });
    trigger.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.show(trigger);
      }
    });
  }
  handleSwiper() {
    if (this.swiperOption) this.swiperOption.destroy();
    this.swiperOption = new Swiper(this.querySelector(".swiper"), {
      slidesPerView: "auto",
      spaceBetween: 8,
      mousewheel: true,
    });
  }
  reset() {
    const step1 = this.querySelector('[data-step="1"]');
    const step2 = this.querySelector('[data-step="2"]');
    if (step1 && step2) {
      step2.classList.add("hidden");
      step1.classList.remove("hidden");
    }
    this.selectedSize = [];
    this.currentLocation = null;
    this.querySelectorAll(".store-location-drawer__submit button").forEach(
      (button) => button.removeAttribute("disabled")
    );
    this.querySelectorAll(".store-location-drawer__submit button").forEach(
      (button) => button.classList.remove("loading")
    );
    this.querySelectorAll(".store-location-drawer__option").forEach((option) =>
      option.classList.remove("active")
    );
    const input = this.querySelector(".store-location-drawer__input input");
    if (input) input.value = "";
    const results = this.querySelector(".store-location-drawer__results");
    if (results) results.classList.add("hidden");
  }
  toggleLoading(button, loading) {
    if (loading) {
      button.setAttribute("disabled", "true");
      button.classList.add("loading");
      button
        .querySelector(".loading-overlay__spinner")
        .classList.remove("hidden");
    } else {
      button.removeAttribute("disabled");
      button.classList.remove("loading");
      button.querySelector(".loading-overlay__spinner").classList.add("hidden");
    }
  }
  onSizeSubmit(e) {
    if (this.selectedSize.length === 0) return;
    let button = e.currentTarget;
    this.toggleLoading(button, true);

    setTimeout(() => {
      this.querySelector('[data-step="2"]').classList.remove("hidden");
      this.querySelector('[data-step="1"]').classList.add("hidden");
      this.toggleLoading(button, false);
    }, 500);
  }
  searchLocation(e) {
    // Get the location from the input
    // render location list
    e.preventDefault();
    let button = this.querySelector('form [data-action="search-submit"]');
    let query = this.querySelector(".store-location-drawer__input input").value;
    this.toggleLoading(button, true);
    this.querySelector(".store-location__list").innerHTML = ''
    this.stockForShippingMethod(this.skuSelected, this.storeCodes, (data,sku) => {
      this.toggleLoading(button, false);
      let storeAvailable = Object.keys(data)
      storeAvailable.map((key) => {
        let codigo = key.split('/')[0]
       let store = this.storeForRender.find((s) => {
         return s.properties.Codigo == codigo
        })
        if(store){
          store.available = true
          store.sku = sku
        }
      })
       this.renderLocations();
    });
    // if (query.trim() && this.currentLocation) {
    //   setTimeout(() => {
    //     this.toggleLoading(button, false);
    //     this.renderLocations();
    //   }, 500);
    // }
  }
  renderStore(store) {
    const item = this.storeTemplate.content
      .querySelector(".store-location__store")
      .cloneNode(true);
      store.properties.name
    let address = store.properties.name ? store.properties.name + ' - ' + store.properties.Direccion : store.properties.Direccion;
    let schedule = store.properties.Horario.replace(']]>','');
    let option =''
     this.variantData.forEach((item) => {
      if (item.sku === store.sku) {
       option = item[this.sizeIndex]
      }
    });

    item.querySelector("[data-address]").textContent = address;
    item.querySelector("[data-schedule]").textContent = schedule;
    item.querySelector("[data-options]").textContent = option;
    item.querySelector(
      "a"
    ).href = `https://maps.google.com/?q=${store.geometry.coordinates[1]},${store.geometry.coordinates[0]}`;
    return item;
  }
  stockForShippingMethod(skuModal, storeCodes, callback) {
    
    skuModal.forEach((sku) => {
    
    const data = JSON.stringify({
      ean: sku,
      sale_channel: "scalperscompany.myshopify.com",
      tiendas: storeCodes,
    });
    fetch("https://madre.scalperscompany.com/api/stock/stockTiendasEan", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-User-Agent": "Shopify-Cape-Bender",
      },
      body: data,
    })
      .then((response) => response.json())
      .then((data) => {
        if (typeof callback === "function") callback(data,sku);
      })
      .catch((error) => {
        if (typeof callback === "function") callback('error');
      });
    })
  }
  renderLocations() {
    let availableStore = this.storeForRender.filter(store => store.available)
    let list = this.querySelector(".store-location__list");
    const orderAvailableStore = [];
    const orderAvailableStoreECI = [];
    for (let index = 0; index < availableStore.length; index++) {
      const element = availableStore[index];
      if (element.properties.name.includes('ECI') || element.properties.name.includes('eci') || element.properties.name.includes('Eci')) {
        orderAvailableStoreECI.push(element);
      } else {
        orderAvailableStore.push(element);
      }
    }
    orderAvailableStore.sort((a, b) => a.distanceMaps - b.distanceMaps);
    orderAvailableStoreECI.sort((a, b) => a.distanceMaps - b.distanceMaps);
  
    let stores = orderAvailableStore.concat(orderAvailableStoreECI).map((store) => {
      return this.renderStore(store);
    });
    stores.forEach((store) => list.appendChild(store));
    this.querySelector(".store-location-drawer__results").classList.remove(
      "hidden"
    );
  }

  onOptionSelect(e) {
    let value = e.currentTarget.dataset.value;
    this.querySelectorAll(".store-location-drawer__option").forEach((option) => {
      option.classList.remove("active");
    });
    e.currentTarget.classList.add("active");
    this.selectedSize = [];
    this.selectedSize.push(value);
    // this.selectedSize.includes(value)
    //   ? (this.selectedSize = this.selectedSize.filter((v) => v !== value))
    //   : this.selectedSize.push(value);
    this.sizeIndex = this.dataset.sizeIndex;
    this.skuSelected = [];
    this.selectedSize.map((size) => {
      this.variantData.forEach((item) => {
        if (item[this.sizeIndex] === size && item.sku) {
          this.skuSelected.push(item.sku);
        }
      });
    });
  }
  show(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    this.opening = true;
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    document.body.classList.add('drawer-open');


    this.addEventListener(
      "transitionend",
      () => {
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(this, focusElement);
      },
      { once: true }
    );
    this.handleSwiper();
    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    document.body.classList.remove('drawer-open');

    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
    this.reset();
  }
  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
  initAutocomplete() {
    this.address1Field = document.querySelector(
      ".store-location-drawer__input input"
    );

    this.autocomplete = new google.maps.places.Autocomplete(
      this.address1Field,
      {
        fields: ["address_components", "geometry"],
        types: [],
      }
    );

    this.autocomplete.addListener(
      "place_changed",
      this.fillInAddress.bind(this)
    );
  }
  fillInAddress() {
    const place = this.autocomplete.getPlace();

    this.currentLocation = {
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
    };
    // get all store information
    fetch(window.storeKML)
      .then((response) => response.text())
      .then((data) => {
        let xml = new DOMParser().parseFromString(data, "text/html");
        var finalJSON = toGeoJSON.kml(xml);
        var storeCodes = [];
        // map store data then render
        let storeForRender = [];
        finalJSON.features.forEach((value, key) => {
          var a = new google.maps.LatLng(
            parseFloat(place.geometry.location.lat()),
            parseFloat(place.geometry.location.lng())
          );
          var b = new google.maps.LatLng(
            value.geometry.coordinates[1],
            value.geometry.coordinates[0]
          );
          var distanceMaps = (
            google.maps.geometry.spherical.computeDistanceBetween(a, b) / 1000
          ).toFixed(2);
          if (distanceMaps <= 50) {
            storeCodes.push(value.properties.Codigo);
            value.distanceMaps = distanceMaps;
            storeForRender.push(value);
          }
        });

        storeForRender.sort(
          (a, b) => a.distanceMaps - b.distanceMaps
        );
        this.storeForRender = storeForRender;
        this.storeCodes = storeCodes;
      });
  }
}

customElements.define("store-location-drawer", StoreLocationDrawer);